import React from "react";
import { toJS } from 'mobx';
import { inject, observer } from "mobx-react";
import {Button} from 'antd';
import { WeaTableNew } from "comsMobx";
import { amkjzgStore } from '../../stores/amkjzg';
//import { getListKey } from '../../util';
import { WeaDatePicker,WeaRightMenu,WeaSelect,WeaBrowser } from "ecCom";
import { observable } from 'mobx';

const WeaTable = WeaTableNew.WeaTable;

export interface AmkjzgStore {
  Amkjzg: amkjzgStore;
}

@inject('Amkjzg')
@observer
export default class amkjzg extends React.Component<AmkjzgStore, any> {
  @observable startdate: string = '';
  @observable hcstatus: string = '';
  @observable hctype: string = '';
  @observable branch: string = '';
  @observable department: string = '';
  @observable bgdd: string = '';
  // constructor(props) {
  //   super(props);
  //   const { Amkjzg } = this.props;
  //   Amkjzg.dataKey({date:""});
  // }
  

  componentDidMount() {
    var date = new Date();
    var seperator1 = "-";
    //var seperator2 = ":";
    //var month = date.getMonth() + 1<10? "0"+(date.getMonth() + 1):date.getMonth() + 1;
    //var strDate = date.getDate()<10? "0" + date.getDate():date.getDate();
    // var currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate
    // 		+ " "  + date.getHours()  + seperator2  + date.getMinutes()
    // 		+ seperator2 + date.getSeconds();
    //var currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate;
    this.startdate = date.getFullYear() + seperator1  + "01" ;

    const { Amkjzg } = this.props;
    Amkjzg.getSlectOption({});
    Amkjzg.dataKey({startdate:this.startdate});
  }


  parseColumns = (columns) => {
    return columns.map((col) => {
      let oldwidth = col.oldWidth || '5%';
      let widthInt = parseFloat(oldwidth.replace('%', ''));
      if (widthInt <= 0) {
        widthInt = 5;
      }
      col.oldWidth = `${widthInt}%`;
      return col;
    })
  }

  tableWidth = (_?: any) => {
    const { Amkjzg } = this.props;
    return Amkjzg.originalTableWidth;
  }

  render() {
    const { Amkjzg } = this.props;
    //console.log(Amkjzg.hcstatusoptions);
    //console.log(Amkjzg.hctypeoptions);
    //console.log(Amkjzg.flstoptions);
    return (
      <WeaRightMenu
      datas={[]}
       >
      <div>
      <div style={{display: "inline"}}>
          <div style={{display: "inline"}}>Start Date </div>
          <WeaDatePicker
            format="yyyy-MM"
            value={this.startdate}
            onChange={value => {this.startdate=value;}}
            needSecond={true}
          />
          <div style={{display: "inline",paddingLeft: "10px"}}>HC Status</div>
          <WeaSelect
            style={{margin: '10px 10px',verticalAlign: 'middle' ,width: 120 }}
            options={toJS(Amkjzg.hcstatusoptions)}
            value={this.hcstatus}
            viewAttr={2}
            onChange={(v, showname) => {
             // this.setState({ value: v });
              this.hcstatus =v;
              console.log("v", v, "showname:", showname);
            }}
          />
          <div style={{display: "inline",paddingLeft: "10px"}}>HC type</div>
          <WeaSelect
            style={{margin: '10px 10px',verticalAlign: 'middle' ,width: 120 }}
            options={toJS(Amkjzg.hctypeoptions)}
            value={this.hctype}
            viewAttr={2}
            onChange={(v, showname) => {
              //this.setState({ value: v });
              this.hctype =v;
              console.log("v", v, "showname:", showname);
            }}
          />
          <div style={{display: "inline",paddingLeft: "10px"}}>Branch</div>
          <WeaSelect
            style={{margin: '10px 10px',verticalAlign: 'middle' ,width: 120 }}
            options={toJS(Amkjzg.flstoptions)}
            value={this.branch}
            viewAttr={2}
            onChange={(v, showname) => {
           //   this.setState({ value: v });
              this.branch=v;
              console.log("v", v, "showname:", showname);
            }}
          />
          
          <div style={{display: "inline",paddingLeft: "10px"}}>Department</div>
          <div style={{display: "inline-block",verticalAlign: "middle",margin: "10px"}}>
          <WeaBrowser
            inputStyle={{ width: 150 }}
            type={4}
            title="部门"
            tabs={[
              {
                isSearch: false,
                key: "2",
                name: "组织结构",
                selected: false,
                showOrder: 0
              },
              {
                dataParams: { list: "1" },
                isSearch: true,
                key: "1",
                name: "按列表",
                selected: false,
                showOrder: 0
              }
            ]}
            onChange={(ids, names, datas) =>{console.log(ids,names,datas);this.department=ids;}}
            linkUrl="/spa/hrm/engine.html#/hrmengine/organization?showTree=false&type=department&id="
          />  
          </div>

          <div style={{display: "inline",paddingLeft: "10px"}}>Location</div>
          <div style={{display: "inline-block",verticalAlign: "middle",margin: "10px"}}>
            <WeaBrowser
              inputStyle={{ width: 150 }}
              type={262}
              title="办公地点"
              linkUrl="/spa/hrm/engine.html#/hrmengine/officeLocation?id="
              onChange={(ids, names, datas) =>{console.log(ids,names,datas);this.bgdd=ids;}}
          />
          </div>
          <div style={{display: "inline",paddingLeft: "20px"}}><Button type="button" style={{ color: "#fff",backgroundColor: "#2db7f5",borderColor:"#2db7f5"}} class="ant-btn" onClick={()=>{Amkjzg.dataKey({startdate:this.startdate,hcstatus:this.hcstatus,hctype:this.hctype,branch:this.branch,department:this.department,bgdd:this.bgdd})}}>Query</Button></div>
          <div style={{display: "inline",paddingLeft: "20px"}}><Button type="button" style={{ color: "#fff",backgroundColor: "#2db7f5",borderColor:"#2db7f5"}} class="ant-btn" onClick={()=>{Amkjzg.doExcelExpost(this.startdate,this.hcstatus,this.hctype,this.branch,this.department,this.bgdd)}}>Export</Button></div>
          <div style={{display: "inline",paddingLeft: "20px"}}><Button type="button" style={{ color: "#fff",backgroundColor: "#2db7f5",borderColor:"#2db7f5"}} class="ant-btn" onClick={()=>{window.open(Amkjzg.exp_url)}}>Down</Button></div>
        </div>

      <WeaTable
        className="cube-list-table"
        // register_table={Amkjzg.register_table}
        comsWeaTableStore={Amkjzg.newTable}
        tableWidth={this.tableWidth}
        getColumns={this.parseColumns}
        needScroll={true}
        heightSpace={10}
      //  rowKey={getListKey}
        hasOrder={true}
      />     
    </div>
    </WeaRightMenu>
    );
  }

}




// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/amkjzg/index.tsx